
export default {
  props: {
    steps: {
      type: Array,
      required: true
    },
    collapsed: {
      type: Boolean,
      default: false
    }
  }
}
